<template>
<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
width="27" height="27"
viewBox="0 0 171 171">
        <g stroke-width="1">
			<path d="M56.0025,30.78c-21.40172,0 -38.9025,17.28703 -38.9025,38.58187c0,43.6718 49.54992,66.54305 66.2625,80.37l2.1375,1.81687l2.1375,-1.81687c16.71258,-13.82695 66.2625,-36.6982 66.2625,-80.37c0,-21.29484 -17.50078,-38.58187 -38.9025,-38.58187c-11.88984,0 -22.36359,5.51742 -29.4975,13.89375c-7.1339,-8.37633 -17.60765,-13.89375 -29.4975,-13.89375zM56.0025,37.62c11.16844,0 20.8807,5.65102 26.61188,14.21438l2.88563,4.275l2.88563,-4.275c5.73117,-8.56336 15.44344,-14.21438 26.61188,-14.21438c17.72789,0 32.0625,14.1743 32.0625,31.74188c0,37.27266 -41.93508,58.16672 -61.56,73.53c-19.62492,-15.36328 -61.56,-36.25734 -61.56,-73.53c0,-17.56758 14.32125,-31.74187 32.0625,-31.74187z">
			</path>
		</g>
</svg>
</template>
<script>
export default {
    name: 'icon-like-outline',
};
</script>
<style>


</style>
